<template>
    <div class="auto-optimization">
        <cBody :wrap="false">
            <header slot="header" class="c-body-header" style="background:white;padding:0;">
                <div class="header-row">
                    <div class="header-row-left">
                        <button @click="showEdit" class="header-button-primary small">新建自动优化规则</button>
                    </div>
                    <div class="header-row-right" style="position:relative">
                        <Dropdown trigger="click">
                            <Input
                                placeholder="请点击选择"
                                v-model.trim="ruleKeyword"
                                class="header-search"
                                icon="android-search"
                                style="width:3rem"
                            />
                            <DropdownMenu slot="list">
                                <DropdownItem v-if="!filterRuleList.length">
                                    <div class="rule-dropdown-item">没有匹配项</div>
                                </DropdownItem>
                                <template v-else>
                                    <DropdownItem v-for="item in filterRuleList" :key="item.id">
                                        <div @click.stop="onSelectRule(item.id)" class="rule-dropdown-item">
                                            <p class="rule-dropdown-item-left showregular">{{item.name}}</p>
                                            <div class="rule-dropdown-item-right">
                                                <i
                                                    class="icon icon-checkbox"
                                                    :class="{active:ruleArr.includes(`${item.id}`)}"
                                                ></i>
                                            </div>
                                        </div>
                                    </DropdownItem>
                                </template>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>
            </header>
            <section slot="section" class="c-body-section">
                <table class="c-body-table">
                    <tbody class="table-tbody">
                        <!-- 规则表头 -->
                        <tr class="table-tr summary">
                            <td class="table-td-primary" v-for="item in ruleField" :key="item.name">{{item.name}}</td>
                        </tr>
                        <tr v-if="!ruleDetailArr.length" class="table-tr">
                            <td colspan="7" class="table-td-primary">未选择自动优化规则</td>
                        </tr>
                        <!-- 规则数据 -->
                        <tr class="table-tr" v-for="(item,index) in ruleDetailArr" :key="index">
                            <td width="10%" class="table-td-primary">{{item.id}}</td>
                            <td width="25%" class="table-td-primary" :title="item.name">
                                <p class="showregular" style="max-width:4rem">
                                    <i v-if="item.defaultStatus==1" class="icon-default-status">Default</i>
                                    <span>{{item.name}}</span>
                                </p>
                            </td>
                            <td width="10%" class="table-td-primary">{{dimensionValue[item.type]}}</td>
                            <td width="10%" class="table-td-primary">{{item.time+timeList[item.timeType]}}</td>
                            <td width="20%" class="table-td-primary">
                                <p
                                    style="line-height:0.25rem"
                                    v-for="(condition,i) in item.conditionText"
                                    :key="i"
                                >{{condition}}</p>
                            </td>
                            <td width="10%" class="table-td-primary">{{item.status==1?'开':'关'}}</td>
                            <td width="15%" class="table-td-primary">
                                <span @click="removeRule(index)" class="table-td-btn" style="padding:0.1rem">移除</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </section>
        </cBody>
        <optimizationModal
            v-model="editParams"
            :showStatus="false"
            :type="'add'"
            :show.sync="show.add"
            @on-save="postEdit"
        />
    </div>
</template>
<script>
import { mapState } from 'vuex';
import cBody from '@/components/commons/cBody.vue';
import optimizationModal from '@/components/optimizationModal.vue';
export default {
    name: 'autoOptimization',
    components: { cBody, optimizationModal },
    data() {
        return {
            //规则搜索关键字
            ruleKeyword: '',
            //规则表头
            ruleField: [{ name: 'ID' }, { name: '名称' }, { name: '维度' }, { name: '时间范围' }, { name: '条件' }, { name: '状态' }, { name: '操作' }],
            //全部的规则数组
            ruleList: [],
            //规则参数
            editParams: {},
            show: {
                add: false,
            },
        };
    },
    computed: {
        ...mapState({
            editParamTemplate: state => state.autoOptimization.editParamTemplate,
            statusList: state => state.autoOptimization.statusList,
            dimensionValue: state => state.autoOptimization.dimensionValue,
            timeList: state => state.autoOptimization.timeList,
            quotaList: state => state.autoOptimization.quotaList,
            quotaValue: state => state.autoOptimization.quotaValue,
            unitList: state => state.autoOptimization.unitList,
            mathValue: state => state.autoOptimization.mathValue,
        }),
        campaignParams() {
            return this.$store.state.newPromotion.campaignParams;
        },
        //已选的规则id数组
        ruleArr() {
            return this.campaignParams.ruleIds == '' ? [] : this.campaignParams.ruleIds.split(',');
        },
        //已选的规则详细数组
        ruleDetailArr() {
            return this.ruleList.filter(item => this.ruleArr.includes(`${item.id}`));
        },
        //关键字过滤后的规则列表
        filterRuleList() {
            return this.ruleList.filter(item => item.name.includes(this.ruleKeyword));
        },
    },
    created() {
        this.getRuleList();
        this.editParams = this.editParamTemplate();
    },
    methods: {
        /**
         * @desc 获取自动优化规则
         */
        async getRuleList() {
            const res = await this.$axios.get(this.$port.rule.getRuleList, {
                params: { status: 0, page: 1, pageSize: 10000 },
            });
            const rules = res.data && res.data.rules || [];
            rules.forEach(item => {
                if (item.week != 0) {
                    item.time = item.week;
                    item.timeType = 'week';
                }
                if (item.day != 0) {
                    item.time = item.day;
                    item.timeType = 'day';
                }
                if (item.hour != 0) {
                    item.time = item.hour;
                    item.timeType = 'hour';
                }
                item.conditionText = [];
                item.conditionArr = [];
                item.conditionObject = this.editParamTemplate().conditionObject;
                item.conditions.forEach(con => {
                    item.conditionArr.push(con.indicator);
                    item.conditionObject[con.indicator] = con;
                    item.conditionText.push(
                        `${this.quotaList[con.indicator] + this.mathValue[con.operator] + con.indicatorValue + this.unitList[con.indicator]}`
                    );
                });
            });
            this.ruleList = rules;
        },
        /**
         * @desc 选择/反选规则
         * @params id:number 要选择/反选的id
         */
        onSelectRule(id) {
            const arr = [...this.ruleArr];
            const index = arr.indexOf(`${id}`);
            index > -1 ? arr.splice(index, 1) : arr.push(id);
            this.campaignParams.ruleIds = arr.join(',');
        },
        /**
         * @desc 移除规则
         * @param {Number} index 要移除的规则索引
         */
        removeRule(index) {
            const arr = [...this.ruleDetailArr];
            arr.splice(index, 1);
            this.campaignParams.ruleIds = arr.map(item => item.id).join(',');
        },
        /**
         * @desc 显示新增/编辑规则
         */
        showEdit() {
            this.editParams = this.editParamTemplate();
            this.show.add = true;
        },
        /**
         * @desc 发送新增/编辑规则请求
         */
        async postEdit() {
            const editParams = this.editParams;
            const params = {
                name: editParams.name,
                type: editParams.type,
                execute: editParams.type,
                status: editParams.status,
                week: 0,
                day: 0,
                hour: 0,
                conditions: [],
            };
            //事件范围
            params[editParams.timeType] = editParams.time;
            //指标
            editParams.conditionArr.forEach(item => {
                params.conditions.push(editParams.conditionObject[item]);
            });
            const port = this.modalType == 'edit' ? this.$port.rule.updateRule : this.$port.rule.addRule;
            const res = await this.$axios.post(port, params, { headers: { 'Content-Type': 'application/json' } });
            this.$axios.commonCallback(res, '修改成功');
            this.campaignParams.ruleIds = [...this.ruleArr, res.data.ruleId].join(',');
            this.getRuleList();
        },
    },
};
</script>

<style lang="scss">
/* 自动优化 */
.auto-optimization {
    #c-body {
        .table-tr {
            line-height: 0.6rem !important;
            height: 0.6rem !important;
            .table-td-primary:nth-of-type(2) {
                text-align: left;
                padding: 0 0.1rem;
            }
        }
        .ivu-select-dropdown {
            max-height: 3rem;
            overflow: auto;
            .ivu-dropdown-item {
                padding: 0;
                width: 3rem;
                .rule-dropdown-item {
                    display: flex;
                    line-height: 0.3rem;
                    padding: 0 0.1rem;
                    justify-content: space-between;
                    align-items: center;
                    .rule-dropdown-item-left {
                        flex: 1 1 auto;
                    }
                    .rule-dropdown-item-right {
                        flex: 0 0 0.4rem;
                        display: flex;
                        justify-content: flex-end;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/NewPromotion/autoOptimization.vue